import React, { useState } from 'react';
import "../Home/craft.css";
import Background from "../../assets/images/Craft/background.jpg";
import '@fortawesome/fontawesome-free/css/all.min.css';
import Bg from "../../assets/images/background/banner.jpg";
import { Link } from 'react-router-dom';


//import background services images
import img1 from "../../assets/images/Product/product1.jpg";
import img2 from "../../assets/images/Product/product2.jpg";
import img3 from "../../assets/images/Product/product3.jpg";
import img4 from "../../assets/images/Product/product4.jpg";


const Craft = () => {

    // service data list (keeps structure same)
    const services = [
        {
            icon: '<i class="fas fa-user-check"></i>',
            heading: "Attendance System",
            text: "   Revolutionize your HR operations with a secure and intelligent attendance system.",
            image: img1,
            route: '/products/attendance-system',
        },
        {
            icon: '<i class="fas fa-user-plus"></i>',
            heading: "Lead Management",
            text: " Convert more leads into customers with a centralized, automated lead management platform.",
            image: img2,
            route: '/products/lead-management',
        },
        {
            icon: '<i class="fas fa-cogs"></i>',
            heading: "Odoo Services",
            text: " A complete solution for businesses that deal with sales, purchases, inventory, and accounts.",
            image: img3,
            route: '/products/oddo-services',

        },
        {
            icon: '<i class="fas fa-chart-line"></i>',
            heading: "Sales & Accounting",
            text: " As an official Odoo development partner, we offer complete ERP solutions customized to your business.",
            image: img4,
            route: '/products/sales-accounting',
        },
    ];


    return (
        <div>
            <section
                className="services-one"
                style={{ backgroundImage: `url(${Background})` }}
            >
                <div className="auto-container">
                    {/* Sec Title */}
                    <div className="sec-title centered">
                        <h2 className="sec-title_heading">Our Company Products</h2>
                        {/* <div className="sec-title_text sec-sub-ma">
                              Our Products will solve business problems
                        </div> */}
                    </div>

                    <div className="row clearfix">
                        {services.map((service, index) => (
                            <div key={index} className="service-block_one col-lg-6 col-md-6 col-sm-12">
                                <div
                                    className={`service-block_one-inner wow fadeInUp`}
                                    data-wow-delay="0ms"
                                    data-wow-duration="1500ms"
                                >
                                    <div
                                        className="service-block_one-icon"
                                        dangerouslySetInnerHTML={{ __html: service.icon }}
                                    />
                                    <h5 className="service-block_one-heading">{service.heading}</h5>
                                    <div className="service-block_one-text">{service.text}</div>

                                    <div
                                        className="service-block_one-overlay"
                                        style={{
                                            backgroundImage: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url(${service.image})`
                                        }}
                                    >

                                        <div className="service-block_one-overlay-inner">
                                            <div className="upper-box">
                                                <div
                                                    className="service-block_one-icon-two"
                                                    dangerouslySetInnerHTML={{ __html: service.icon }}
                                                />
                                                <h5 className="service-block_one-heading-two">
                                                    <Link to={service.route}>{service.heading}</Link>
                                                </h5>
                                            </div>
                                            <div className="service-block_one-text-two">{service.text}</div>
                                            {/* Button Box */}
                                            <div className="service-block_one-button">
                                                <Link className="btn-style-two theme-btn btn-item" to={service.route}>
                                                    <div className="btn-wrap">
                                                        <span className="text-one">
                                                            Read more <i className="fa-solid fa-arrow-right fa-fw" />
                                                        </span>
                                                        <span className="text-two">
                                                            Read more <i className="fa-solid fa-arrow-right fa-fw" />
                                                        </span>
                                                    </div>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                </div>
            </section>
        </div>
    );
};

export default Craft;
